import React, { useEffect, useState } from "react";
import DriverCashTransactionsList from "../../components/DriverCashTransactions/DriverCashTransactionsList";
import ListPagination from "../../components/Common/ListPagination";
import DriverCashTransactionsModal from "../../components/DriverCashTransactions/DriverCashTransactionsModal";
import Permission from "../../components/Common/Permission";
import FilterButton from "../../components/Common/FilterButton";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverCashTransactionsActions from "../../store/actions/DriverCashTransactions";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";

const DriverCashTransactions = (props) => {
  const { getDriverCashTransactionsList, driverCashTransactionsList } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [modalState, setModalState] = useState("");
  const allActions = MenuActionsMappings[MenuNames.DRIVER_CASH_TRANSACTIONS];
  const filterFields = ["driver_id", "start_date", "end_date"];
  const handleClick = (type) => {
    setModalState(type);
  };

  const fileDownloadError = () => {
    console.log("There was some error while making download object");
  };
  const handleClose = () => {
    setModalState("");
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      getDriverCashTransactionsList(props.activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      getDriverCashTransactionsList(props.activeFilters, pageRequest);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <div className="Driver-Cash-Transactions-View container">
      <FlexContainer>
        <Heading>Driver cash transactions</Heading>
        <div
          style={{ maxWidth: "320px" }}
          className="actionBar mb-20 flex items-end justify-end"
        >
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter")}
            />
          </Permission>
        </div>
      </FlexContainer>
      <DriverCashTransactionsList
        driverCashTransactionsList={driverCashTransactionsList}
      />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && (
        <DriverCashTransactionsModal
          modalState={modalState}
          handleClose={handleClose}
          filterFields={filterFields}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const { DriverCashTransactions } = state;
  return {
    driverCashTransactionsList:
      DriverCashTransactions.driverCashTransactionsList,
    nextPage: DriverCashTransactions.nextPage,
    prevPage: DriverCashTransactions.prevPage,
    activeFilters: DriverCashTransactions.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverCashTransactionsList: bindActionCreators(
      DriverCashTransactionsActions.getDriverCashTransactionsList,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverCashTransactions);
